// src/utils/rtlCache.js
import createCache from '@emotion/cache';
import stylisRTLPlugin from 'stylis-plugin-rtl';

// Default cache: no RTL plugin, for English/other LTR languages
export const cacheLtr = createCache({
    key: 'muiltr',
    prepend: true,
});

// RTL cache: runs every style through stylis-plugin-rtl
export const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [stylisRTLPlugin],
    prepend: true,
});
